import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Redirect component for the root path.
 * - Contact users land on /dashboard (their only dashboard).
 * - Everyone else lands on /kpi-dashboard, which is the default analytics view.
 */
const RootRedirect: React.FC = () => {
  const { user, loading } = useAuth();

  // Wait for auth to load before redirecting
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  // If not logged in, redirect to login (preserve query and hash so Azure AD return can complete)
  if (!user) {
    const search = window.location.search || '';
    const hash = window.location.hash || '';
    return <Navigate to={`/login${search}${hash}`} replace />;
  }

  const landingPath = user.class === 'contact' ? '/dashboard' : '/kpi-dashboard';
  return <Navigate to={landingPath} replace />;
};

export default RootRedirect;
